import {
  DEFAULT_TREND_PERIOD,
  TREND_PERIODS,
  TrendSelection,
} from "@repo/ui/hooks/use-trend-controls"

/** What the page's URL has picked. */
export const toTrendSelection = (
  period: (typeof TREND_PERIODS)[number] | undefined,
  from: string | undefined,
  to: string | undefined,
): TrendSelection => {
  if (from && to) {
    return {
      period: "custom",
      range: { from: new Date(from), to: new Date(to) },
    }
  }
  return { period: period ?? DEFAULT_TREND_PERIOD }
}
